import $ from 'jquery';

class HomeFocusAreas {
    constructor() {
    }

    init() {
        const containers = $('.focus-area-cards-values-wrapper-value');

        containers.get().forEach((container) => {
            const element = container.querySelector('.focus-area-cards-values-wrapper-value-number');
            if ($(container).hasClass('hidden-value')) {
                $(container).css('display', 'flex');
                this.fitTextToContainer(container, element);
                $(container).css('display', 'none');
            } else {
                this.fitTextToContainer(container, element);
            }
        });
    }

    fitTextToContainer(container, element) {
        let fontSize = 260;
        element.style.fontSize = `${fontSize}px`;

        while (element.scrollWidth > container.clientWidth && (fontSize > 5)) {
            fontSize -= 1;
            element.style.fontSize = `${fontSize}px`;
        }
    }
}

export default HomeFocusAreas;

$(() => {
    const homeFocusAreas = new HomeFocusAreas();
    homeFocusAreas.init();
});